import * as React from 'react';

const Welcome = () => {
    return (
        <div style={{ height: '100%', display: 'grid', placeItems: 'center', fontSize: 60, fontWeight: 500 }}>
            Welcome
        </div>
    );
};

export default Welcome;